import type { EndMixedSessionInput, EndSessionResponse } from "@memorang/types";

const endSession = async (
	_input: EndMixedSessionInput,
): Promise<EndSessionResponse> => {
	return {
		sessionId: "",
	};
};

export { endSession };
